export const VARIATIONS = {
    Front: "Front",
    Back: "Back",
    Top: "Top",
    Left: "Left",
    Right: "Right",
    Bottom: "Bottom",
};

export const NO_IMAGE_URL = "/images/noimage.jpg";

export const PRODUCT_MATCH_STEPS = {
    compare: "IMAGE_COMPARE",
    zoom: "ZOOM_COMPARE",
    match: "PRODUCT_MATCH",
};
